/* __next_internal_client_entry_do_not_use__ Default,expertCardTailwindVariants auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import ImageWrapper from 'helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { parseStyleParams } from 'lib/utils/style-param-utils';
import { getCtaStyle } from 'lib/utils/cta-utils';
import { RemixIcon } from 'helpers/RemixIcon';
import { getTestProps } from 'lib/testing/utils';
import { tv } from 'tailwind-variants';
import useDictionary from 'lib/hooks/useDictionary';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const ExpertCardItem = (props)=>{
    const isEditing = useIsEditing();
    const { expertData } = props?.fields || {};
    const { RenderingIdentifier } = props?.params || {};
    const { getDictionaryValue } = useDictionary();
    // Extract data from expertData structure
    const expertProfileImage = expertData?.fields?.picture;
    const expertName = expertData?.fields?.firstname?.value && expertData?.fields?.lastname?.value ? {
        value: `${expertData.fields.firstname.value} ${expertData.fields.lastname.value}`
    } : undefined;
    const expertRole = expertData?.fields?.jobtitle;
    const expertTestimonial = expertData?.fields?.quoteText;
    const expertLinkedInLink = expertData?.fields?.linkedInURL?.value ? {
        value: {
            href: expertData.fields.linkedInURL.value,
            target: '_blank'
        }
    } : undefined;
    const getExpertProfileUrl = (currentUrl)=>{
        // Remove single letter slug pattern: /our-people/[a-z]/[slug] -> /our-people/[slug]
        if (currentUrl.includes('/our-people/')) {
            // Match pattern: /our-people/[single-letter-a-z]/[rest-of-path]
            const pattern = /\/our-people\/([a-z])\/(.+)/;
            const match = currentUrl.match(pattern);
            if (match) {
                // Return /our-people/[rest-of-path]
                return `/our-people/${match[2]}`;
            }
        }
        return currentUrl;
    };
    const expertCtaLink = expertData?.url ? {
        value: {
            href: getExpertProfileUrl(expertData.url),
            text: getDictionaryValue('ExpertCardCtaText') || 'Find out more'
        }
    } : undefined;
    const styles = parseStyleParams(props.params, [
        'cta1'
    ]);
    const { container, imageSection, contentSection, contentTop, contentBottom, imageWrapper, testimonialQuote, expertDetails, expertNameTV, expertRoleTV, linkedInWrapper, linkedInIcon, separator, ctaWrapper, ctaLink } = expertCardTailwindVariants();
    return /*#__PURE__*/ _jsxs("article", {
        className: container(),
        "data-component": "authorable/shared/lists/expertcard",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        ...getTestProps(`expert-card-${props?.rendering?.uid}`),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: imageSection(),
                children: expertProfileImage?.value?.src ? /*#__PURE__*/ _jsx(ImageWrapper, {
                    field: expertProfileImage,
                    className: imageWrapper(),
                    ...getTestProps(`expert-image`)
                }) : /*#__PURE__*/ _jsx(ImageWrapper, {
                    field: {
                        value: {
                            src: '/assets/profile_placeholder.png',
                            alt: 'No image'
                        }
                    },
                    className: imageWrapper(),
                    ...getTestProps(`related-profile-image-placeholder`)
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: contentSection(),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: contentTop(),
                        children: [
                            expertTestimonial?.value && /*#__PURE__*/ _jsx(RichTextWrapper, {
                                field: expertTestimonial,
                                className: `text-component-expert-testimonial ${testimonialQuote()}`,
                                ...getTestProps(`expert-testimonial`)
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: expertDetails(),
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                                className: expertNameTV(),
                                                field: expertName,
                                                tag: "div",
                                                ...getTestProps(`expert-name`)
                                            }),
                                            /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                                className: expertRoleTV(),
                                                field: expertRole,
                                                tag: "div",
                                                ...getTestProps(`expert-role`)
                                            })
                                        ]
                                    }),
                                    expertLinkedInLink?.value?.href && /*#__PURE__*/ _jsx(LinkWrapper, {
                                        ctaComponentClass: "component-card-item-button-1-color",
                                        field: expertLinkedInLink,
                                        className: linkedInWrapper(),
                                        editable: false,
                                        "aria-label": `View ${expertName?.value || 'expert'} LinkedIn profile`,
                                        suppressNewTabIcon: true,
                                        ...getTestProps(`expert-linkedin`),
                                        children: /*#__PURE__*/ _jsx(RemixIcon, {
                                            name: "linkedin-box-fill",
                                            size: "xl",
                                            className: linkedInIcon()
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: contentBottom(),
                        children: [
                            expertCtaLink?.value?.href && /*#__PURE__*/ _jsx("div", {
                                className: separator()
                            }),
                            expertCtaLink?.value?.href && /*#__PURE__*/ _jsx("div", {
                                className: ctaWrapper(),
                                children: /*#__PURE__*/ _jsx(LinkWrapper, {
                                    ctaComponentClass: "component-card-item-button-1-color",
                                    className: ctaLink(),
                                    field: expertCtaLink,
                                    ctaIcon: "arrow-right",
                                    ctaIconSize: "s",
                                    ctaStyle: getCtaStyle(styles.cta1, 'tertiary'),
                                    "aria-label": expertCtaLink?.value?.text ? `${expertCtaLink?.value?.text} for ${expertName?.value || 'expert'}` : `Find out more about ${expertName?.value || 'expert'}`,
                                    ...getTestProps(`expert-cta`)
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const ExpertCard = ExpertCardItem;
export const Default = withStandardComponentWrapper(ExpertCard);
export const expertCardTailwindVariants = tv({
    slots: {
        container: [
            'flex',
            'flex-col',
            'md:flex-row',
            'lg:flex-col',
            'w-full',
            'h-full',
            'overflow-hidden',
            'rounded-general-border-radius-card',
            'shadow-color-black-alpha-10',
            'shadow-[0_0_8px_0]'
        ],
        imageSection: [
            'relative',
            'w-full',
            'md:w-1/2',
            'lg:w-full',
            'overflow-hidden',
            'aspect-[4/3]',
            'md:aspect-square',
            'lg:aspect-[4/3]',
            'rounded-t-general-border-radius-card',
            'md:rounded-l-general-border-radius-card',
            'md:rounded-tr-none',
            'lg:rounded-l-none',
            'lg:rounded-t-general-border-radius-card'
        ],
        contentSection: [
            'flex',
            'flex-col',
            'flex-1',
            'w-full',
            'md:w-1/2',
            'lg:w-full',
            'gap-spacing-spacing-24',
            'py-component-card-item-landscape-content-1-col-padding-y',
            'px-component-card-item-landscape-content-1-col-padding-x',
            'bg-component-featureCard-surface',
            'rounded-b-general-border-radius-card',
            'md:rounded-r-general-border-radius-card',
            'md:rounded-bl-none',
            'lg:rounded-r-none',
            'lg:rounded-b-general-border-radius-card'
        ],
        contentTop: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-24'
        ],
        contentBottom: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-24',
            'mt-auto'
        ],
        imageWrapper: [
            'w-full',
            'h-full',
            'object-cover'
        ],
        testimonialQuote: [
            'text-white',
            'font-typography-font-family-header',
            'text-typography-font-size-header-small',
            'font-normal',
            'leading-typography-line-height-small',
            'text-left',
            'relative'
        ],
        expertDetails: [
            'flex',
            'items-start',
            'justify-between',
            'gap-spacing-spacing-16'
        ],
        expertNameTV: [
            'text-white',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'font-semibold',
            'text-left',
            'leading-normal'
        ],
        expertRoleTV: [
            'text-white',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'font-normal',
            'leading-normal',
            'text-left',
            'mt-spacing-spacing-4'
        ],
        linkedInWrapper: [
            'flex',
            'w-10',
            'h-10',
            '!p-0',
            'text-white',
            'items-center',
            'justify-center',
            'hover:opacity-80',
            'transition-opacity',
            'duration-200',
            '[&:hover_svg]:!text-white'
        ],
        linkedInIcon: [
            'text-white'
        ],
        separator: [
            'w-full',
            'h-[2px]',
            'bg-white'
        ],
        ctaWrapper: [
            'flex',
            'p-spacing-spacing-2',
            'items-center',
            'justify-between',
            'self-stretch'
        ],
        ctaLink: [
            '!text-white',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'font-semibold',
            'leading-typography-line-height-xxsmall',
            'flex',
            'items-center',
            'justify-between',
            'w-full',
            'hover:opacity-80',
            'transition-opacity',
            'duration-200',
            '[&:hover_svg]:!text-white'
        ]
    }
});
